import React, { useContext } from "react";
import FormType, { FieldConfigs } from "../../../../shared/components/FormType";
import { UserFormWrapper } from "./Styled";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";
import { EmployeeRolesDropdown } from "../../../../configs/employee";
import AvatarUpload from "../AvatarUpload";

interface FormContainerProps {
    validated: boolean;
    requiredData: any;
    isOwnProfile: boolean;
    mergeUser: Function;
}

const FormContainer = ({ validated, requiredData, isOwnProfile, mergeUser }: FormContainerProps) => {
    const { user: currentUser } = useContext(AuthenticationContext);
    const isManager = currentUser.role === ROLE.MANAGER;

    const Informationfields: FieldConfigs[] = [
        { label: "Trạng thái", type: "toggle", key: "is_active", disabled: !isManager },
        { label: "Mã nhân viên", type: "text", key: "user_code", required: true, disabled: !isManager },
        {
            label: "Tên đăng nhập",
            type: "text",
            key: "username",
            required: true,
            disabled: !isOwnProfile && !isManager,
        },
        {
            label: "Họ và tên",
            type: "text",
            key: "display_name",
            required: true,
            disabled: !isOwnProfile && !isManager,
        },
        {
            label: "Số điện thoại",
            type: "text",
            key: "phone_number",
            required: true,
            validation: "phone",
            disabled: !isOwnProfile && !isManager,
        },
        {
            label: "Email",
            type: "text",
            key: "email",
            required: true,
            disabled: !isOwnProfile && !isManager,
            validation: "email",
        },
        {
            label: "Vai trò",
            type: "dropdown",
            key: "role",
            required: true,
            options: EmployeeRolesDropdown,
            disabled: !isManager,
        },
        {
            label: "Ảnh đại diện",
            type: "custom",
            key: "avatar",
            customComponent: (
                <AvatarUpload
                    userId={requiredData.id}
                    currentAvatar={requiredData.avatar}
                    onAvatarChange={(avatarUrl) => mergeUser({ avatar: avatarUrl })}
                />
            ),
        },
    ];

    const handleChangeUser = (updateUserContact: any) => {
        mergeUser(updateUserContact);
    };

    return (
        <UserFormWrapper>
            <FormType
                title={"Thông tin tài khoản"}
                fields={Informationfields}
                validated={validated}
                requireData={requiredData}
                mergeFormData={handleChangeUser}
            />
        </UserFormWrapper>
    );
};

export default FormContainer;
